// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"3781554e","656":"1064bb9b","756":"d5389f6b","831":"8a4ba377","968":"10816ac0"}[chunkId] + ".chunk.js";
};